export const PostLoginExcludedPagesArray: Array<string> = ['touchidsettings', '/widgets/'];

export enum PostLoginEvents {
    ActionStarted = 'post-login-action-start',
    ActionCompleted = 'post-login-action-complete',
    FlowStart = 'post-login-flow-start',
    FlowResumed = 'post-login-flow-resume',
    FlowSkipped = 'post-login-flow-resume',
    FlowError = 'post-login-flow-error',
    FlowCompleted = 'post-login-flow-completed',
}

export enum PostLoginFlowExecutionType {
    Skipped = 0,
    Interrupted = 1,
    Regular = 2,
}

export const PostLoginStateKey = 'PostLoginActionsState';

export const DefaultPostLoginActionState = {
    actionsOptions: null,
    completed: false,
    lastActionInExecution: undefined,
    interrupted: false,
    correlationID: undefined,
};
